(() => {
  const align = () => {
    document.querySelectorAll('.superr-free-gift-widget').forEach(widget => {
      widget.querySelectorAll('.sfg-gift-price-free').forEach(label => {
        if (label.textContent.trim() === 'FREE') label.textContent = 'Gratis';
      });
      const drawer = widget.closest('#CartDrawer');
      if (widget.dataset.pageType === 'product') {
        const trust = document.querySelector('#MainContent .kinich-trust');
        if (trust && trust.nextElementSibling !== widget) trust.after(widget);
      }

      if (!drawer) return;
      const summary = drawer.querySelector('.drawer__footer > .cart-drawer__footer');
      if (summary && widget.nextElementSibling !== summary) summary.before(widget);
    });
  };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; align(); });
  });
  observer.observe(document.body, {childList:true, subtree:true});
  align();
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
})();
